var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHierarchy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 29.3334C27.3932 29.3334 29.3333 27.3933 29.3333 25.0001C29.3333 22.6068 27.3932 20.6667 25 20.6667C22.6067 20.6667 20.6666 22.6068 20.6666 25.0001C20.6666 27.3933 22.6067 29.3334 25 29.3334Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3334 10.6667C27.5425 10.6667 29.3334 8.87589 29.3334 6.66675C29.3334 4.45761 27.5425 2.66675 25.3334 2.66675C23.1242 2.66675 21.3334 4.45761 21.3334 6.66675C21.3334 8.87589 23.1242 10.6667 25.3334 10.6667Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66663 10.6667C8.87577 10.6667 10.6666 8.87589 10.6666 6.66675C10.6666 4.45761 8.87577 2.66675 6.66663 2.66675C4.45749 2.66675 2.66663 4.45761 2.66663 6.66675C2.66663 8.87589 4.45749 10.6667 6.66663 10.6667Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.44004 10.6934C7.73337 14.4001 11.2267 16.8934 15.16 16.8934C15.1734 16.8934 15.1867 16.8934 15.2 16.8934L19.9067 16.8801C21.9334 16.8534 23.7467 18.2267 24.2934 20.2001V22.6667C24.2934 23.2267 24.7467 23.6801 25.32 23.6801C25.88 23.6801 26.3334 23.2267 26.3334 22.6667V7.68008C26.3334 7.12008 25.88 6.66675 25.32 6.66675C24.76 6.66675 24.2934 7.12008 24.2934 7.68008V16.5067C23.12 15.4667 21.5867 14.8267 19.92 14.8267C19.9067 14.8267 19.9067 14.8267 19.8934 14.8267L15.1867 14.8401C15.1734 14.8401 15.1734 14.8401 15.16 14.8401C12.1067 14.8401 9.37337 12.9067 8.37337 10.0134C8.21337 9.60008 7.8267 9.33341 7.40004 9.33341C7.29337 9.33341 7.17337 9.36008 7.0667 9.38675C6.53337 9.57341 6.25337 10.1601 6.44004 10.6934Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHierarchy);
export default __webpack_public_path__ + "static/media/hierarchy.e384ffcc99ecb965e8b8607e0eb4c648.svg";
export { ForwardRef as ReactComponent };